module.exports = __webpack_public_path__ + "static/media/website-01.b490c4d5.png";